import { render, staticRenderFns } from "./FacilityButton.vue?vue&type=template&id=6645d6cc&scoped=true&"
import script from "./FacilityButton.vue?vue&type=script&lang=js&"
export * from "./FacilityButton.vue?vue&type=script&lang=js&"
import style0 from "./FacilityButton.vue?vue&type=style&index=0&id=6645d6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645d6cc",
  null
  
)

export default component.exports